import { useEffect, useState } from "react";

/**
 * True once the element has scrolled into view, and stays true. Always true
 * when not enabled. A callback ref, so it follows the element if it remounts.
 */
export function useInView<T extends Element>(enabled: boolean) {
  const [element, setElement] = useState<T | null>(null);
  const [inView, setInView] = useState(!enabled);

  useEffect(() => {
    if (inView) return;
    if (!element) return;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setInView(true);
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, inView]);

  return { ref: setElement, inView };
}
